import { VinhubAttachmentForSend } from './vinhub.model';

export class VinhubSendMessage {
  message: string | null = null;
  attachments: VinhubAttachmentForSend[] | null = null;
  videoId: number | null = null;
  insuranceGroupName: string = null;
  repliedToMessageId?: number | null;
}

export class VinhubChatHistoryRequest {
  chatId: number;
  from: string;
  to: string;
  attachmentsOnly: boolean;
}
